// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "link-2k47L";
export { _1 as "__esModule", _2 as "link" }
export default { "__esModule": _1, "link": _2 }
